import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { useEffect, useState } from "react";

const KpiSlider = ({
  data = [],
  renderItem,
  spacing = 16,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const [sliderRef, instanceRef] = useKeenSlider({
    mode: "snap",
    slides: {
      perView: "auto",     // ← Most important change
      spacing,
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    breakpoints: {
      "(max-width: 1024px)": { slides: { perView: "auto", spacing: 12 } },
      "(max-width: 768px)":  { slides: { perView: "auto", spacing: 12 } },
    },
    rubberband: false,
  });

  // Force update after render (helps with width calculation)
  useEffect(() => {
    if (instanceRef.current) {
      setTimeout(() => {
        instanceRef.current?.update();
      }, 100);
    }
  }, [data, instanceRef]);

  return (
    <div className="relative w-full overflow-hidden">
      <div ref={sliderRef} className="keen-slider">
        {data.map((item, index) => (
          <div 
            key={index} 
            className="keen-slider__slide"
            style={{ 
              minWidth: "unset",
              width: "auto",
              flexShrink: 0 
            }}
          >
            {renderItem(item, index)}
          </div>
        ))}
      </div>

      {/* Arrows */}
      <button
        onClick={() => instanceRef.current?.prev()}
        disabled={currentSlide === 0}
        className="absolute left-2 top-1/2 -translate-y-1/2 z-30 bg-white shadow-lg rounded-full w-10 h-10 flex items-center justify-center border border-gray-200 hover:bg-gray-50 disabled:opacity-40"
      >
        ←
      </button>

      <button
        onClick={() => instanceRef.current?.next()}
        className="absolute right-2 top-1/2 -translate-y-1/2 z-30 bg-white shadow-lg rounded-full w-10 h-10 flex items-center justify-center border border-gray-200 hover:bg-gray-50"
      >
        →
      </button>
    </div>
  );
};

export default KpiSlider;